<script setup lang="ts">
import type { ResultItem } from '@/utils/file';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed } from 'vue';

import { downloadResultsAsCsv } from '@/utils/file';
import TablePageFooter from '@/components/footers/TablePageFooter.vue';
import ExportAsCsvIconBtn from '@/components/iconBtns/ExportAsCsvIconBtn.vue';
import DraftsTable from '@/components/tables/DraftsTable.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useDraftsJobBookingViewData from '@/composables/data/useDraftsJobBookingViewData';
import useCommonRouteQuery from '@/composables/routeQueries/useCommonRouteQuery';
import { defCurPage, defPageSize } from '@/constants/routeQuery';

const { queryCurPage, queryPageSize } = useCommonRouteQuery({
  queryCurPage: defCurPage,
  queryPageSize: defPageSize,
});

const { isFetchingAllData, allData } = useDraftsJobBookingViewData(
  queryCurPage,
  queryPageSize,
);

const draftsData = computed(() => allData.value?.drafts || {});

const resultsForCsv = computed<ResultItem[]>(() => {
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!draftsData.value?.results) return [];
  return draftsData.value.results.map(
    (
      item: NonNullable<openapi.JobDraftListContentOpenapi['results']>[number],
    ) => {
      const { ...resultItem } = item;
      return resultItem;
    },
  );
});
</script>

<template>
  <div :class="$style.draftsJobBookingView" data-testid="draftsJobBookingView">
    <PageContentWrapper>
      <h2 class="g-h2">
        Choose the job from your drafts, edit and book in simple way
      </h2>
      <TablePageShadowWrapper :class="$style.tablePageShadowWrapper">
        <DraftsTable :data="draftsData.results" :loading="isFetchingAllData" />
        <TablePageFooter
          :cur-page="queryCurPage"
          :page-size="queryPageSize"
          :total="draftsData.count"
        >
          <ExportAsCsvIconBtn
            :disabled="isFetchingAllData"
            @click="downloadResultsAsCsv(resultsForCsv, 'drafts')"
          />
        </TablePageFooter>
      </TablePageShadowWrapper>
    </PageContentWrapper>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.draftsJobBookingView {
}
  .tablePageShadowWrapper {
    max-width: variables.$tableWrapperWidth;
  }
</style>
